import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';

/**
 * Component providing version and other information about the system.
 */
@Component({
	selector: 'about',
	templateUrl: './about.component.html',
	styleUrl: './about.component.css'
})
export class AboutComponent implements OnInit {
	LOCALIZATION: any;
	version: any = {};

	constructor(
		private http: HttpClient,
		private configService: ConfigService,
		private userService: UserService,
		private ngbmodalService: NgbActiveModal
	) { }

	ngOnInit(): void {
		this.LOCALIZATION = this.userService.LOCALIZATION;

		let config = this.configService.getConfig();
		this.version.uiBuild = config.version.ui;
		this.version.uiName = config.version.name;

		this.http.get(config.version.serverVersionURL).subscribe(
			(response: any) => {
				let created = new Date(response.buildDate);
				this.version.buildDate = created.toLocaleDateString('en-US') + ' ' + created.toLocaleTimeString('en-US');
				this.version.build = response.build;
			},
			(error) => {
				console.error('Failed to fetch server version', error);
			}
		);
	}

	/**
	 * Closes the modal.
	 */
	close(): void {
		this.ngbmodalService.dismiss();
	}
}
